export default __webpack_public_path__ + "static/media/info.0432e949.svg";